// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__yXVzg","child1":"style_child1__NvNZu","child2":"style_child2__O9lMU"};